var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-share"},[_c('PageBackComponent',{staticClass:"news-share__back"}),_c('div',{staticClass:"news-share__right"},[_c('div',{staticClass:"news-share__icons"},[_c('ShareNetworksComponent')],1),_c('span',{staticClass:"news-share__date"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.date)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }